import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { fetchHiredlyXContent } from "../../../redux/actions/company_action";
import {
  CardContainer,
  CardListContainer,
  CardNumber,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  LineBreak,
  TaglineTitle,
} from "./styles";

let query = `
    stepsTitle
    stepsSection {
      title
      description
      image {
        data {
          attributes {
            url
          }
        }
      }
    }
  `;

export default function HXSteps() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = await dispatch(fetchHiredlyXContent(query));

    const { stepsTitle, stepsSection } = response || {};
    setSolutions(stepsTitle);
    setSolutionsCard(stepsSection);
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <TaglineTitle
        dangerouslySetInnerHTML={{ __html: solutions }}
      ></TaglineTitle>

      <CardContainer>
        {solutionsCard?.map((cards, cardIndex) => (
          <>
            <CardListContainer key={cardIndex} cardNumber={cardIndex}>
              <CardNumber>{cardIndex + 1}</CardNumber>
              <CardTextContainer>
                <CardText
                  type={"title"}
                  cardNumber={cardIndex}
                  dangerouslySetInnerHTML={{ __html: cards?.title }}
                ></CardText>
                <CardText
                  type={"desc"}
                  cardNumber={cardIndex}
                  dangerouslySetInnerHTML={{ __html: cards?.description }}
                ></CardText>
              </CardTextContainer>
            </CardListContainer>
            {cardIndex !== solutionsCard.length - 1 && <LineBreak />}
          </>
        ))}
      </CardContainer>
    </GridContainerStyled>
  );
}
